import ValProCard from "./ValProCard";

export default ValProCard;